import { isChord } from '../controls/keymap';

export class VisitorNameDisplay {
  visible = true;

  handleKey(
    event: Pick<KeyboardEvent, 'code' | 'repeat' | 'ctrlKey' | 'altKey' | 'metaKey'>,
    editing: boolean
  ): boolean {
    if (event.code !== 'KeyN' || event.repeat || isChord(event) || editing) return false;
    this.visible = !this.visible;
    return true;
  }
}

export function createVisitorNameDisplay(doc: Document) {
  const display = new VisitorNameDisplay();
  const key = (event: KeyboardEvent): void => {
    if (doc.body.classList.contains('entry-open')) return;
    const editing =
      event.target instanceof HTMLElement &&
      Boolean(
        event.target.closest('input, select, textarea, [contenteditable="true"], [role="dialog"]')
      );
    if (display.handleKey(event, editing)) event.preventDefault();
  };
  return {
    get visible(): boolean {
      return display.visible;
    },
    mount(): void {
      doc.addEventListener('keydown', key);
    },
    dispose(): void {
      doc.removeEventListener('keydown', key);
    },
  };
}
